import React, { useState, useRef, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Button } from 'react-bootstrap';
// import logo from 'assets/images/eb-logo.svg'
import logo from 'assets/images/coin-bazzar1.png';
import infoIco from 'assets/images/i-circle.svg';
import './styles.scss';
import { Formik, Field, Form } from 'formik';
import * as Yup from 'yup';
import SignUpService from './services/signup.service';
import Toast from 'shared/common/toast';
import { toast } from 'react-toastify';
import OtpModal from 'shared/common/modal/otp_modal';
import LoginService from 'pages/login/services/login.service';
import hidden from '../../assets/images/hidden.svg';
import eye from '../../assets/images/eye.svg';
import OtpPopup from 'shared/common/otp-modal/otpModal';
import api from 'api/client';
import {
  ACK_FAIL,
  ACK_SUCCESS,
  OTP_SENT_TO_MESSAGE,
  OTP_VERIFY_FAILURE,
  OTP_VERIFY_SUCCESS,
  SIGNUP_SUCCESS,
} from 'constants/messages.constant';
import format from 'string-template';
import { userStore } from 'store/UserStore';

interface PropsType { }

const SignUp: React.FC<PropsType> = () => {
  const ref = useRef(null);
  const [otpData, setOtpData] = useState<OtpData>({
    value: '',
    ackMessage: '',
    ackMessageType: 'success',
  });
  const [usernameError, setUsernameError] = useState('');
  const [otp, setOtp] = useState('');
  const history = useHistory();
  const [countryCode, setCountryCode] = useState('+91');
  const [verify, setVerify] = useState(false);
  const [isLoading, setLoading] = React.useState(false);
  const [isOtpVerified, setIsOtpVerified] = useState<boolean>(false);
  const [modalShow, setModalShow] = React.useState(false);
  const [txtSuscces, setTxtSuscces] = useState('');
  const [txtError, setTxtError] = useState('');
  const [mobile, setMobile] = useState('');
  const [resendCount, setResendCount] = useState(0);
  const [isShowPwd, setShowPwd] = React.useState(false);
  const [isShowCnfPwd, setShowCnfPwd] = useState(false);
  const [userValues, setUserValues] = useState('');
  const { setLoginData } = userStore();

  useEffect(() => {
    if (otpData.value?.length === 6) onSuccess();
  }, [otpData.value]);

  const resetOtpData = () => {
    setOtpData({
      value: '',
      ackMessage: '',
      ackMessageType: 'success',
    });
  };

  const signUp = async (val) => {
    // setModalShow(true);
    setUserValues(val);
    setLoading(true);
    setMobile(countryCode + val.mobile);
    try {
      const res: any = await SignUpService.signup({
        ...val,
        mobile: countryCode + val.mobile,
      });
      if (res) {
        setTxtSuscces('OTP has been sent to the registered mobile');
        setModalShow(true);
        setIsOtpVerified(false);
      }
      setLoading(false);
    } catch (err: any) {
      let error = JSON.parse(JSON.stringify(err));
      handleAwsErrors(error.code);
      setLoading(false);
    }
  };

  const handleAwsErrors = (errorCode) => {
    if (errorCode === 'UsernameExistsException') {
      return toast.error('User with given mobile number already exists.', {
        className: 'toast-position-signup',
      });
    } else {
      return toast.error('Oops! Something went wrong.', {
        className: 'toast-position-signup',
      });
    }
  };

  const onEmailOtpSuccess = async (emailOtp) => {
    try {
      setLoading(true);
      const res: any = await LoginService.verifyMailOtp({ code: emailOtp });
      setLoading(false);
      if (res) {
        setModalShow(false);
        setIsOtpVerified(true);
      }
    } catch (err: any) {
      setLoading(false);
      toast.error(err.data.errors[0].title, {
        className: 'toast-position-signup',
      });
    }
  };

  const LoginFunc = async (val) => {
    try {
      const res: any = await LoginService.login(
        countryCode + val.mobile,
        val.password
      );

      if (res) {
        setLoginData({
          customer: {},
          customerId: '',
          selectedAccount: {},
          user: {},
          tokens: {
            accessToken: res.getAccessToken(),
            idToken: res.getIdToken(),
            refreshToken: res.getRefreshToken(),
          },
          userData: res.getIdToken().decodePayload(),
        });
        api.setAuthAccess(res.accessToken.jwtToken);
        api.setAuthRefresh(res.refreshToken.token);
        api.setToken(res.idToken.jwtToken);

        // if (ID) {
        //   setCustomerId(ID);
        //   getProfile(ID);
        // }
        history.push('/customers');
      }

      setLoading(false);
    } catch (err: any) {
      let error = JSON.parse(JSON.stringify(err));
      handleAwsErrors(error.code);
      setLoading(false);
    }
  };

  const onSuccess = async () => {
    setLoading(true);
    try {
      const res: any = await LoginService.verifyOTP(mobile, otpData.value);
      setLoading(false);
      if (res) {
        console.log('resv', res, userValues);
        LoginFunc(userValues);
        setOtpData({
          ...otpData,
          ackMessage: OTP_VERIFY_SUCCESS,
          ackMessageType: ACK_SUCCESS,
        });
        toast.success(SIGNUP_SUCCESS, {
          className: 'toast-position-signup',
        });
        // setTimeout(() => {
        //   history.push('/signin');
        // }, 2000);
      }
    } catch (err: any) {
      setOtpData({
        value: '',
        ackMessage: OTP_VERIFY_FAILURE,
        ackMessageType: ACK_FAIL,
      });
      setLoading(false);
      toast.error(err.message, {
        className: 'toast-position-signup',
      });
    }
  };

  const sendOtpThroughMail = async (values: any) => {
    setTxtSuscces('');
    setTxtError('');
    setLoading(true);
    try {
      //update user email
      // const email_res : any = await LoginService.updateUser(token.idToken.payload.sub, {'email' : {'value':values.email,'isVerified':false}}, token.idToken.jwtToken);

      //sent otp for mail
      const res: any = await LoginService.sendOTPToEmail();

      setLoading(false);

      if (res) {
        setTxtError('');
        setTxtSuscces('OTP has been sent to the email');
        setModalShow(true);

        setIsOtpVerified(false);
      }
    } catch (err: any) {
      setLoading(false);
      setTxtSuscces('');
      setTxtError('There was an error in sending the OTP');
      if (err) {
        toast.error(err.data.errors[0].title, {
          className: 'toast-position-signup',
        });
      } else {
        toast.error('Something went wrong', {
          className: 'toast-position-signup',
        });
      }
    }
  };

  const sendOtp = async (mobileNo: any) => {
    setLoading(true);
    try {
      const res: any = await LoginService.sendOTP(mobileNo);
      setLoading(false);
      setResendCount((prevState) => prevState + 1);
      if (res) {
        setTxtError('');
        setTxtSuscces(
          `OTP has been ${resendCount > 1 ? 'resent' : 'sent'
          } to the registered mobile`
        );
        setModalShow(true);

        setIsOtpVerified(false);
      }
    } catch (err: any) {
      setLoading(false);
      setTxtSuscces('');
      setTxtError('There was an error in sending the OTP');
      toast.error(err.message, {
        className: 'toast-position-signup',
      });
    }
  };

  return (
    <div>
      <Toast />
      <div className='login-wrapper'>
        <div className='login-banner d-none d-sm-block d-sm-flex'>
          <div className='logoss'>
            {' '}
            <img className='paynearlogo' src={logo} alt='' />
          </div>
          {/* <img style={{width:"100%", height:"100%"}} src={logo} alt='' /> */}
        </div>
        <div className='login-form'>
          <div className='login-form-group'>
            <div className='mt-0 my-3 d-sm-block d-md-none'>
              <img src={logo} alt='' />
            </div>
            <div className='title'>
              <h3>Create your account</h3>
              <p>Start your bullion journey today</p>
            </div>
            <Formik
              innerRef={ref}
              initialValues={{
                name: '',
                mobile: '',
                countryCode: '+91',
                email: '',
                password: '',
                confirm_password: '',
                agree: false,
              }}
              onSubmit={(values, { setSubmitting }) => {
                setSubmitting(false);
                signUp(values);
              }}
              validationSchema={Yup.object().shape({
                name: Yup.string()
                  .matches(/^[a-zA-Z ]+$/, 'Special characters are not allowed')
                  .trim('Name is invalid')
                  .required('Name is required'),
                mobile: Yup.string()
                  .matches(/^[0-9]+$/, 'Please enter a valid mobile number')
                  .test(
                    'len',
                    'Please enter a valid mobile number',
                    (val) => val?.length === 10
                  )
                  .required('Invalid mobile number'),
                email: Yup.string()
                  .email('Invalid email')
                  .required('Email is required'),
                password: Yup.string()
                  .required('Password is required')
                  .matches(
                    /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/,
                    'The password must be at least 8 characters and it must contain at least one uppercase, one lowercase, one number and one special character.'
                  ),
                confirm_password: Yup.string()
                  .oneOf([Yup.ref('password'), null], 'Passwords do not match')
                  .required('Confirm Password is required'),

                agree: Yup.boolean()
                  .required('The terms and conditions must be accepted.')
                  .oneOf([true], 'The terms and conditions must be accepted.')
                  .default(false),
              })}
            >
              {({ errors, touched, values, setFieldValue }) => (
                <Form translate={undefined} autoComplete='off'>
                  <div className='form-group mb-1'>
                    <label className='form-label'>Name as per PAN card</label>
                    <Field
                      type='text'
                      placeholder='Eg: RAJ SHARMA'
                      name='name'
                      className='form-control'
                      autoFocus={true}
                      onChange={(e) => {
                        const value = e.target.value.toUpperCase();
                        const regex = /^[A-Za-z ]+$/; // Allows only letters and spaces
                        if (regex.test(value) || value === '') {
                          setFieldValue('name', value);
                        }
                      }}
                    />
                    <div className='error'>
                      {errors.name && touched.name && (
                        <small id='my-helper-text' className='text-muted'>
                          <img src={infoIco} alt='' />
                          {errors.name}
                        </small>
                      )}
                    </div>
                  </div>

                  <div className='form-group mb-1'>
                    <label className='form-label'>Mobile</label>
                    <div className='input-group mb-2'>
                      <div className='input-group-text' id='basic-addon1'>
                        <select
                          className='form-control country-select'
                          onChange={(event) =>
                            setCountryCode(event.target.value)
                          }
                          value={countryCode}
                          disabled
                        >
                          <option value={'+91'}>+91</option>
                        </select>
                      </div>
                      <Field
                        type='text'
                        placeholder=''
                        name='mobile'
                        className='form-control'
                        onChange={(e) => {
                          if (
                            e.target.value.length > 10 ||
                            /[^0-9]/.test(e.target.value)
                          )
                            return;
                          setFieldValue('mobile', e.target.value);
                        }}
                      />
                    </div>

                    <div className='error'>
                      {errors.mobile && touched.mobile && (
                        <small id='my-helper-text'>
                          <img src={infoIco} alt='' />
                          {errors.mobile}
                        </small>
                      )}
                    </div>
                  </div>

                  <div className='form-group mb-1'>
                    <label className='form-label'>Email</label>
                    <Field
                      type='text'
                      placeholder=''
                      name='email'
                      className='form-control'
                    />
                    <div className='error'>
                      {errors.email && touched.email && (
                        <small id='my-helper-text'>
                          <img src={infoIco} alt='' />
                          {errors.email}
                        </small>
                      )}
                    </div>
                  </div>

                  <div className='form-group mb-1'>
                    <label className='form-label'>Password</label>
                    <div className={`input-group mb-2 ${errors.password && touched.password && errors.password.length > 20 ? 'mt-5' : 'mt-1'}`}>
                      <Field
                        type={isShowPwd ? 'text' : 'password'}
                        name='password'
                        style={{ position: 'unset' }}
                        className='form-control'
                      />

                      <div
                        className='input-group-text'
                        id='basic-addon1'
                        style={{
                          border: '1px solid #ced4da',
                          borderLeft: '0px',
                          backgroundColor: 'white',
                          borderRadius: '0rem 0.25rem 0.25rem 0rem',
                        }}
                      >
                        <a href='#' onClick={() => setShowPwd(!isShowPwd)}>
                          <img
                            className='m-2'
                            style={{ width: '16px' }}
                            src={isShowPwd ? hidden : eye}
                            alt=''
                          />
                        </a>
                      </div>
                    </div>
                    <div className='error ms-5' >
                      {errors.password && touched.password && (
                        <small >
                          <img src={infoIco} alt='' />
                          {errors.password}
                        </small>
                      )}
                    </div>
                  </div>

                  <div className='form-group mb-1'>
                    <label className='form-label'>Confirm Password</label>
                    <div className='input-group mb-1'>
                      <Field
                        type={isShowCnfPwd ? 'text' : 'password'}
                        name='confirm_password'
                        style={{ position: 'unset' }}
                        className='form-control'
                      />

                      <div
                        className='input-group-text'
                        id='basic-addon1'
                        style={{
                          border: '1px solid #ced4da',
                          borderLeft: '0px',
                          backgroundColor: 'white',
                          borderRadius: '0rem 0.25rem 0.25rem 0rem',
                        }}
                      >
                        <a
                          href='#'
                          onClick={() => setShowCnfPwd(!isShowCnfPwd)}
                        >
                          <img
                            className='m-1'
                            style={{ width: '16px' }}
                            src={isShowCnfPwd ? hidden : eye}
                            alt=''
                          />
                        </a>
                      </div>
                    </div>
                    <div className='error'>
                      {errors.confirm_password && touched.confirm_password && (
                        <small id='my-helper-text'>
                          <img src={infoIco} alt='' />
                          {errors.confirm_password}
                        </small>
                      )}
                    </div>
                  </div>

                  {/* <PasswordChecklist
                    rules={["minLength","specialChar","number","capital"]}
                    minLength={8}
                    value={ref?.current?.values?.password || ''}
                    onChange={(isValid) => {
                      setPasswordStrong(isValid);
                    }}
                  /> */}

                  {/* <div className='form-group mb-2'>
                    <label className='form-label'>
                      Referral Code (Optional)
                    </label>
                    <Field
                      type='text'
                      placeholder=''
                      name='referralCode'
                      className='form-control'
                      onChange={(e) => {
                        setReferralCode(e.target.value);
                        setInvalidRC('');
                        if (e.target.value) {
                          isValidReferral(e.target.value, setFieldError);
                        }
                      }}
                      value={referralCode}
                    />
                    <div className='form-group'>
                      <div className='error-password'>
                        {errors.referralCode && touched.referralCode && (
                          <small id='my-helper-text'>
                            <img src={infoIco} alt='' />
                            {errors.referralCode}
                          </small>
                        )}
                      </div>
                    </div>
                    <div className='d-flex justify-content-between mx-1 my-2'>
                      <div className='font-weight-bold'>
                        <b>{busPartName}</b>
                      </div>
                    </div>
                  </div> */}

                  <div className='form-group my-2'>
                    <label
                      className='cursor-pointer'
                      style={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}
                    >
                      <Field
                        type='checkbox'
                        name='agree'
                        className='custom-checkbox '

                      />
                      <span style={{ lineHeight: 1, fontSize: '14px' }}>
                        I Agree to the{' '}
                        <a
                          href='https://ebullion.in/terms-and-conditions/terms.html'
                          target='_blank'
                          rel='noopener noreferrer'
                          style={{ color: '#393939', fontWeight: 'bold' }}
                        >
                          Terms and conditions
                        </a>
                      </span>
                    </label>
                  </div>
                  <div className='form-group' style={{ marginBottom: '30px' }}>
                    <div className='error'>
                      {errors.agree && touched.agree && (
                        <small id='my-helper-text'>
                          <img src={infoIco} alt='' />
                          {errors.agree}
                        </small>
                      )}
                    </div>
                  </div>
                  <div className='row'>
                    <div className='error'>
                      {usernameError && (
                        <small id='my-helper-text'>
                          <img src={infoIco} alt='' />
                          {usernameError}
                        </small>
                      )}
                    </div>
                    <div className='form-group mb-1 mt-1'>
                      <Button
                        disabled={isLoading}
                        className='w-100 '
                        variant='primary'
                        type='submit'
                      >
                        {!isLoading ? (
                          'Sign up'
                        ) : (
                          <div
                            className='spinner-border text-white'
                            role='status'
                          >
                            <span className='visually-hidden'>Loading...</span>
                          </div>
                        )}
                      </Button>
                    </div>
                  </div>
                </Form>
              )}
            </Formik>

            <div className='text-center sign-in-text'>
              <a onClick={(e) => history.push('/signin')}>
                Already registered? <span>Sign in</span>{' '}
              </a>
            </div>
          </div>
        </div>
      </div>
      {/* <OtpModal
        show={modalShow}
        handleClose={() => setModalShow(false)}
        title={
          verify
            ? 'Enter the OTP sent your registered email address'
            : 'Enter the OTP sent your registered mobile number'
        }
        onSuccess={(otp) => {
          verify ? onEmailOtpSuccess(otp) : onSuccess();
        }}
        resend={verify ? sendOtpThroughMail : sendOtp}
        txtSuscces={txtSuscces}
        loading={isLoading}
        isVerified={isOtpVerified}
        txtError={txtError}
      /> */}
      {/* <OtpModal
        show={modalShow}
        handleClose={() => setModalShow(false)}
        title={'Enter the OTP sent your registered mobile number'}
        onSuccess={(otp) => {
          onSuccess(otp);
        }}
        resend={() => {
          sendOtp(mobile);
        }}
        loading={isLoading}
        txtSuscces={txtSuscces}
        isVerified={isOtpVerified}
        txtError={txtError}
      /> */}
      <OtpPopup
        show={modalShow}
        isLoading={isLoading}
        handleClose={() => {
          resetOtpData();
          setModalShow(false);
        }}
        modalTitle='New user verification'
        modalSubmitBtnText='Verify'
        onSubmit={() => onSuccess()}
        otpLabel={format(OTP_SENT_TO_MESSAGE, {
          suffixDigits: mobile?.slice(-4),
        })}
        enableResendTimer={true}
        resendHandler={() => {
          resetOtpData();
          sendOtp(mobile);
        }}
        otpChangeHandler={(value) => {
          setOtpData({
            value: value,
            ackMessage: '',
            ackMessageType: 'success',
          });
        }}
        resendButtonText='Resend OTP'
        ackMessage={otpData.ackMessage}
        ackMessageType={otpData.ackMessageType}
        numInputs={6}
        otpValue={otpData.value}
        resendInterval={30}
      />
    </div>
  );
};

export default SignUp;
